import { render } from "./main_remotesupport.vue?vue&type=template&id=7372b941&scoped=true"
import script from "./main_remotesupport.vue?vue&type=script&lang=js"
export * from "./main_remotesupport.vue?vue&type=script&lang=js"

import "./main_remotesupport.vue?vue&type=style&index=0&id=7372b941&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7372b941"]])

export default __exports__